import React from 'react'

function Header() {
  return (
    <div>
        <h2>Expense Tracker</h2>
    </div>
  )
}

export default Header;